import React from 'react';
import { Database, Clock, Info } from 'lucide-react';

export default function BatchViewer({ project }) {
    return (
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-blue-600 rounded-xl">
                    <Database className="text-white" size={24} />
                </div>
                <div>
                    <h3 className="text-lg font-black text-gray-900 uppercase tracking-tight">Credit Batch Details</h3>
                    <p className="text-xs text-gray-600 font-medium">Traceable serial numbers for transparency</p>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="border-b border-gray-100">
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Batch ID</th>
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Vintage</th>
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Quantity</th>
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Serial Range</th>
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Issuance Date</th>
                            <th className="text-left py-4 px-4 text-[9px] font-black text-gray-500 uppercase tracking-widest">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {project.batches.map((batch, index) => (
                            <tr key={index} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                                <td className="py-4 px-4">
                                    <span className="text-xs font-bold text-gray-900 uppercase">{batch.batch_id}</span>
                                </td>
                                <td className="py-4 px-4">
                                    <span className="text-xs font-bold text-gray-700">{batch.vintage_year}</span>
                                </td>
                                <td className="py-4 px-4">
                                    <span className="text-xs font-bold text-gray-900">{batch.credit_quantity.toLocaleString()} <span className="text-gray-500">tCO₂e</span></span>
                                </td>
                                <td className="py-4 px-4">
                                    <div className="flex flex-col gap-1">
                                        <span className="text-[10px] font-bold text-gray-600">{batch.serial_number_start}</span>
                                        <span className="text-[10px] font-bold text-gray-600">to {batch.serial_number_end}</span>
                                    </div>
                                </td>
                                <td className="py-4 px-4">
                                    <div className="flex items-center gap-2">
                                        <Clock size={14} className="text-gray-400" />
                                        <span className="text-xs font-bold text-gray-700">{new Date(batch.issuance_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
                                    </div>
                                </td>
                                <td className="py-4 px-4">
                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-wider ${
                                        batch.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-700'
                                    }`}>
                                        {batch.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-4 p-4 bg-blue-50 rounded-xl border border-blue-100">
                <div className="flex items-start gap-3">
                    <Info size={18} className="text-blue-600 mt-0.5 shrink-0" />
                    <div>
                        <p className="text-xs font-bold text-blue-900">Why Serial Numbers Matter</p>
                        <p className="text-[10px] text-blue-700 mt-1 leading-relaxed">Each carbon credit has a unique serial number that prevents double counting. Once retired, these credits are permanently removed from circulation and cannot be resold.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
